import { Component, EventEmitter, Output, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { ProjectOverviewStateService } from 'src/app/services/project-overview-state-service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';

@Component({
  selector: 'quotation-container',
  templateUrl: './quotation-container.component.html',
  styleUrls: ['./quotation-container.component.scss']
})
export class QuotationContainerComponent extends SubscriptionBasedComponent {
  @Output()
  reloadCountChange = new EventEmitter<any>();

  @Input()
  selectedOverview: string;

  @Input()
  parentSubject: Subject<any>;

  constructor(
    private projectOverviewStateService: ProjectOverviewStateService
  ) {
    super();
  }

  ngOnInit() {
    if (this.parentSubject != null) {
      this.parentSubject.subscribe(event => {
        if (event === 'quotation') {
          this.selectedOverview = this.projectOverviewStateService.getSelectedQuotationView();
          if (this.selectedOverview === '') {
            this.changeSelectedView('quotation');
          }
        }
      });
    }
    this.selectedOverview = this.projectOverviewStateService.getSelectedQuotationView();
    if (this.selectedOverview === '') {
      this.changeSelectedView('quotation');
    }
  }

  changeSelectedView(value: string) {
    this.projectOverviewStateService.setSelectedQuotationView(value);
    this.selectedOverview = this.projectOverviewStateService.getSelectedQuotationView();
  }
}
